export const getBubblingPath = (e: React.BaseSyntheticEvent) => {
  // @ts-expect-error
  const path = e.nativeEvent.composedPath()

  return path.filter((el: HTMLElement) => el.id) as HTMLElement[]
}
